import { InputAdornment, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import { SearchSM } from 'untitledui-js-base';
import { FiltersType } from '../hooks';
import { CarRentalStatus } from '../types/rental';

export interface RentalFiltersType {
  search: string;
  status: CarRentalStatus | undefined;
}

export interface RentalsFiltersProps {
  filters: FiltersType<RentalFiltersType>;
  disabled?: boolean;
}

const STATUS_OPTIONS: { value: CarRentalStatus; label: string }[] = [
  { value: 'ongoing', label: 'Probíhající' },
  { value: 'blocked', label: 'Blokované' },
  { value: 'completed', label: 'Dokončené' }
];

export const RentalsFilters = ({ filters: { filters, setFilters }, disabled }: RentalsFiltersProps) => {
  const [searchInput, setSearchInput] = useState(filters.search);

  useDebounce(
    () => {
      if (searchInput !== filters.search) {
        setFilters({ ...filters, search: searchInput });
      }
    },
    2000,
    [searchInput]
  );

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'center' }}
      spacing={{ xs: 1, md: 2 }}
      width={{ xs: 1, md: 'auto' }}
    >
      <TextField
        placeholder="Vyhledat v zápůjčkách"
        variant="outlined"
        value={searchInput}
        size="small"
        disabled={disabled}
        sx={{ minWidth: 320 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchSM color="currentColor" />
            </InputAdornment>
          ),
          sx: { backgroundColor: 'background.paper' }
        }}
        onChange={(e) => setSearchInput(e.target.value)}
      />
      <Select
        size="small"
        displayEmpty
        disabled={disabled}
        value={filters.status ?? ''}
        sx={{ minWidth: 200, backgroundColor: 'background.paper' }}
        onChange={(e) =>
          setFilters({
            ...filters,
            status: e.target.value === '' ? undefined : (e.target.value as CarRentalStatus)
          })
        }
      >
        <MenuItem value="">Vyberte stav...</MenuItem>
        {STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
